import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Plus } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AddPropertyTypeCardProps {
  onClick: () => void;
}

export function AddPropertyTypeCard({ onClick }: AddPropertyTypeCardProps) {
  const { t, i18n } = useTranslation();
  const isRTL = useMemo(() => i18n.language === 'ar', [i18n.language]);

  return (
    <Card
      className="cursor-pointer transition-all duration-300 hover:shadow-xl hover:scale-105 group border-2 border-dashed border-primary/30 hover:border-primary hover:bg-primary/5"
      onClick={onClick}
    >
      <CardHeader className="pb-4">
        <div
          className={cn(
            'flex items-center gap-4',
            isRTL ? 'flex-row-reverse' : 'flex-row'
          )}
        >
          <div className="p-4 rounded-xl bg-primary/10 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300">
            <Plus className="w-5 h-5" />
          </div>
          <div className={cn('flex-1', isRTL && 'text-right')}>
            <CardTitle className="text-xl font-bold">
              {t('templates.admin.addPropertyType.title')}
            </CardTitle>
            <CardDescription className="text-sm font-medium">
              {t('templates.admin.addPropertyType.description')}
            </CardDescription>
          </div>
        </div>
      </CardHeader>

      <CardContent>
        <div
          className={cn(
            'text-center p-8 bg-gradient-to-br from-primary/5 to-primary/10 rounded-xl border-2 border-dashed border-primary/20 group-hover:border-primary/40 transition-all',
            isRTL && 'text-right'
          )}
        >
          <Plus className="w-12 h-12 mx-auto mb-3 text-primary/50 group-hover:text-primary transition-colors" />
          <div className="text-sm font-medium text-muted-foreground group-hover:text-foreground transition-colors">
            {t(
              'templates.admin.addPropertyType.clickToAdd',
              'Click to add new property type'
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
